import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShoppingBag } from "lucide-react";
import { Reveal } from "./Reveal";
import FullImage from "./FullImage";
import api from "../../lib/api";
import { useCurrency } from "../../context/CurrencyContext";

export default function FeaturedProducts() {
  const [products, setProducts] = React.useState([]);
  const { format } = useCurrency();

  React.useEffect(() => {
    api.get("/products/featured").then((r) => setProducts(r.data || [])).catch(() => {});
  }, []);

  if (!products.length) return null;

  return (
    <section className="bg-sand py-20 lg:py-28" data-testid="home-featured-products">
      <div className="max-w-6xl mx-auto px-6">
        <Reveal>
          <div className="flex items-end justify-between gap-6 mb-10">
            <div>
              <p className="uppercase tracking-[0.3em] text-xs text-gold mb-3 inline-flex items-center gap-2">
                <ShoppingBag className="w-4 h-4" /> ÀsÀ Market
              </p>
              <h2 className="font-serif text-4xl lg:text-5xl text-ink leading-tight">From the Shop</h2>
            </div>
            <Link
              to="/shop"
              data-testid="featured-shop-all"
              className="hidden sm:inline-flex items-center gap-2 text-forest font-semibold hover:gap-3 transition-all shrink-0"
            >
              Shop all <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.slice(0, 8).map((p, i) => (
            <Reveal key={p.id} delay={i * 0.05}>
              <Link
                to="/shop"
                data-testid={`featured-product-${p.id}`}
                className="group block bg-cream border border-parchment rounded-2xl overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              >
                <div className="relative">
                  {(p.images || [])[0] ? (
                    <FullImage src={p.images[0]} alt={p.name} className="h-52" />
                  ) : (
                    <div className="h-52 grid place-items-center bg-gold/10 text-gold"><ShoppingBag className="w-8 h-8" /></div>
                  )}
                </div>
                <div className="p-5">
                  <span className="text-xs uppercase tracking-widest text-gold">{p.category}</span>
                  <h3 className="font-serif text-xl text-ink leading-snug mt-1 group-hover:text-forest transition-colors line-clamp-2">{p.name}</h3>
                  <p className="font-serif text-lg text-forest mt-2">{format(p.price)}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 text-center sm:hidden">
          <Link to="/shop" className="inline-flex items-center gap-2 text-forest font-semibold">
            Shop all <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
